
export const homeObjOne = {
  id: 'about',
  lightBg: false,
  lightText: true,
  lightTextdesc: true,
  topLine: 'Premium Bank',
  headline: 'Unlimited Transactions with zero fees',
  description:
    'Get acess to our exclusive app that allows you to send unlimited transactions without getting charged any fees.',
  buttonLabel: 'Get started',
  imgStart: false,
  img: require('../../images/admin-control.svg').default,
  alt: 'Car',
  dark: true,
  primary: true,
  darkText: false,
}
export const homeObjTwo = {
  id: 'discover',
  lightBg: true,
  lightText: false,
  lightTextdesc: false,
  topLine: 'UnLimited access',
  headline: 'Unlimited Transactions with zero fees',
  description:
    'Get acess to our exclusive app that allows you to send unlimited transactions without getting charged any fees.',
  buttonLabel: 'Get started',
  imgStart: true,
  img: require('../../images/disscuss.svg').default,
  alt: 'Car',
  dark: false,
  primary: false,
  darkText: true,
}
export const homeObjThree = {
  id: 'signup',
  lightBg: true,
  lightText: false,
  lightTextdesc: false,
  topLine: 'Premium Bank',
  headline: 'Unlimited Transactions with zero fees',
  description:
    'Get acess to our exclusive app that allows you to send unlimited transactions without getting charged any fees.',
  buttonLabel: 'Get started',
  imgStart: !false,
  img: require('../../images/coder.svg').default,
  alt: 'Car',
  dark: !true,
  primary: !true,
  darkText: !false,
}
